import ssoAxios from '../../config/axios'

const apiUpdateOnboarding = (
	data,
	{ isComplete = true, currentFormStep } = {},
) => ssoAxios.post('/user/onboarding/update', {
	data,
	is_complete: isComplete,
	...(currentFormStep === undefined
		? {}
		: { current_form_step: currentFormStep }),
})

const apiRejectOnboarding = () => ssoAxios.post('/user/onboarding/reject')

export {
	apiRejectOnboarding,
	apiUpdateOnboarding,
}
